// extracted by mini-css-extract-plugin
export default {"resource":"resource--a7WFv","deselectButton":"deselectButton--SmNYN"};